import React from 'react';

import NextImage from 'next/image';

import DAY_END from './assets/afternoon.svg';
import NIGHT_END from './assets/earlyMorning.svg';
import NIGHT_START from './assets/evening.svg';
import MIDDAY from './assets/midday.svg';
import MIDNIGHT from './assets/midnight.svg';
import DAY_START from './assets/morning.svg';
import DAWN from './assets/sunrise.svg';
import DUSK from './assets/sunset.svg';

const SUN_POSITION_ICONS = {
  MIDNIGHT,
  DAWN,
  DUSK,
  MIDDAY,
  DAY_END,
  NIGHT_START,
  NIGHT_END,
  DAY_START,
};

export interface ISunPositionIconProps extends React.SVGProps<SVGSVGElement> {
  sunPosition: keyof typeof SUN_POSITION_ICONS;
  width?: number | `${number}`;
  height?: number | `${number}`;
}

export const SunPositionIcon = ({
  sunPosition,
  height = '32',
  width = '32',
}: ISunPositionIconProps) => {
  const src = SUN_POSITION_ICONS[sunPosition];
  return src ? (
    <NextImage alt="Sun Position Icon" width={width} height={height} src={src} />
  ) : (
    <></>
  );
};
